/**
 * Détermine le texte à afficher pour une localisation
 * Privilégie le nom du POI/établissement, puis la ville, puis l'adresse
 * 
 * @param {Object} location - Objet location
 * @param {string} location.name - Nom du POI/établissement (optionnel)
 * @param {string} location.city - Ville (optionnel)
 * @param {string} location.address - Adresse complète
 * @param {Object} options - Options d'affichage
 * @param {boolean} options.preferCity - Privilégier la ville extraite plutôt que le nom complet
 * @returns {string|null} Texte à afficher ou null si aucune info
 */
export const getDisplayLocation = (location, options = {}) => {
  if (!location) return null;
  
  const { preferCity = false } = options;
  
  // Si on préfère la ville (pour les cartes par exemple)
  if (preferCity) {
    // 1. Champ city explicite
    if (location.city) {
      return location.city;
    }
    
    // 2. Extraire la ville de l'adresse
    if (location.address) {
      return location.address.split(',')[0].trim();
    }
    
    // 3. Fallback sur le nom du POI
    if (location.name) {
      return location.name;
    }
  } else {
    // Mode normal : privilégier le nom du POI
    // 1. Nom du POI/établissement
    if (location.name) {
      return location.name;
    }
    
    // 2. Champ city explicite
    if (location.city) {
      return location.city;
    }
    
    // 3. Extraire la ville de l'adresse
    if (location.address) {
      return location.address.split(',')[0].trim();
    }
  }
  
  return null;
};

/**
 * Détermine l'adresse complète à afficher (pour les détails)
 * Privilégie le nom du POI, puis l'adresse complète
 * 
 * @param {Object} location - Objet location
 * @returns {string} Adresse à afficher
 */
export const getFullDisplayLocation = (location) => {
  if (!location) return 'Adresse inconnue';
  
  // Privilégier le nom du POI pour les établissements
  if (location.name) {
    return location.name;
  }
  
  // Sinon l'adresse complète
  if (location.address) {
    return location.address;
  }
  
  // Fallback sur les coordonnées si disponibles
  if (location.lat && location.lng) {
    return `${location.lat}, ${location.lng}`;
  }
  
  return 'Adresse inconnue';
}; 